import { Vessel, partById } from './vessel'
import { PartCatalog, partDef } from './catalog'

/**
 * Serbatoi da cui un motore preleva, in ordine di consumo.
 * Regola: si risale la catena dei genitori partendo dal motore; ogni serbatoio
 * incontrato entra nel percorso; un disaccoppiatore senza crossfeed interrompe
 * il percorso, perche e li che il razzo si dividera.
 */
export function fuelPathForEngine(vessel: Vessel, catalog: PartCatalog, engineId: string): string[] {
  const engine = partById(vessel, engineId)
  if (!partDef(catalog, engine.defId).engine) {
    throw new Error(`La parte ${engineId} non e un motore`)
  }
  const path: string[] = []
  let cursor = engine.parentId
  while (cursor !== null) {
    const part = partById(vessel, cursor)
    const def = partDef(catalog, part.defId)
    if (def.decoupler && !def.decoupler.crossfeed) break
    if (def.tank) path.push(part.id)
    cursor = part.parentId
  }
  return path
}

export function availablePropellant(vessel: Vessel, path: readonly string[]): number {
  return path.reduce((s, id) => s + partById(vessel, id).propellant, 0)
}

/**
 * Preleva propellente lungo il percorso, svuotando prima i serbatoi vicini.
 * MUTA i serbatoi. Restituisce la quantita effettivamente prelevata, che e
 * minore della richiesta quando il razzo va a secco.
 */
export function drawPropellant(vessel: Vessel, path: readonly string[], amount: number): number {
  if (amount <= 0) return 0
  let residuo = amount
  for (const id of path) {
    if (residuo <= 0) break
    const tank = partById(vessel, id)
    const preso = Math.min(tank.propellant, residuo)
    tank.propellant -= preso
    residuo -= preso
  }
  return amount - residuo
}
